import { render } from "./CruEKS.vue?vue&type=template&id=66836e12&ts=true"
import script from "./CruEKS.vue?vue&type=script&lang=ts"
export * from "./CruEKS.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__